import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectEditingCollection,
  selectUser,
  setSelectedMenu,
  setSelectedMenuId,
} from "../../../redux/features/appData";

import "./HomeScreenContainer.css";
import HrTeamSection from "./HrTeamSection";
import ResponseCardSection from "./RecentAnswersSection";
import { RecentAnswer, TeamMember } from "winslow-core";
import { apiGetHomeScreen } from "../../../services/UserService";
import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import { toastSuccess } from "../../../config";
import { useDispatch } from "react-redux";
import { MENUS } from "../../config/menus";
import { AnswerSidebar } from "./AnswerSidebar";
import TextInput from "../../common/TextInput";
import { setPrompt } from "../../../redux/features/agent/agentSlice";

export default function HomeScreenContainer() {
  const storeUser = useSelector(selectUser);
  const currentCollection = useSelector(selectEditingCollection);

  const [question, setQuestion] = useState<string | null>(null);

  const [questionCount, setQuestionCount] = useState<number | null>(null);
  const [hrTeamMembers, setHrTeamMembers] = useState<TeamMember[]>([]);
  const [recentAnswers, setRecentAnswers] = useState<RecentAnswer[]>([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    loadHomeScreen();
  }, []);

  useEffect(() => {
    loadHomeScreen();
  }, [storeUser]);

  const loadHomeScreen = () => {
    dispatch(setSelectedMenu(MENUS.HOME));
    dispatch(setSelectedMenuId(MENUS.HOME));

    (async () => {
      if (storeUser && storeUser.id && storeUser.currentWorkspaceId) {
        const data = await apiGetHomeScreen(
          storeUser.id,
          storeUser.currentWorkspaceId
        );

        setQuestionCount(data?.questionCount || null);
        setHrTeamMembers(data?.hrTeamMembers || []);
        setRecentAnswers(data?.recentAnswers || []);
      }
    })();
  };

  const handleAsk = () => {
    if (!question || question.trim() === "") {
      toast("Please enter a question to ask Winslow", toastSuccess);
      return;
    }

    dispatch(setSelectedMenu(MENUS.COLLECTION_ASK));
    dispatch(setSelectedMenuId(MENUS.COLLECTION_ASK));
    dispatch(setPrompt(question));
    navigate(`/agent/${currentCollection?.id}`);
  };

  return (
    <div className="home-screen">
      {/* User Avatar and Welcome Message */}
      <div className="home-screen-user-container">
        <div className="home-screen-user">
          <img src={storeUser?.avatarURL || ""} alt="User Avatar" />
        </div>
        <div className="home-screen-user-avatar-text">
          Hi, {storeUser?.firstName}. Welcome back!
        </div>
      </div>
      <div className="home-screen-question-container">
        <img
          className="home-screen-question-icon"
          src="/icons/ai_outline.svg"
          alt=""></img>
        <TextInput
          title="home-screen-question"
          placeholder="Ask Winslow a question about your documents..."
          value={question || ""}
          handleSubmit={handleAsk}
          setValue={setQuestion}
        />

        <button
          className="home-screen-question-button"
          title="ask"
          onClick={handleAsk}
        />
      </div>

      <div className="home-screen-main-row">
        <HrTeamSection hrTeamMembers={hrTeamMembers} />

        <div
          className="activity-widget"
          onClick={() => {
            navigate(`/collection/${currentCollection?.id}/stats`);
            dispatch(setSelectedMenu(MENUS.COLLECTION_STATS));
            dispatch(setSelectedMenuId(undefined));
          }}>
          <div className="activity-widget-wrapper">
            <div className="row">
              <div className="activity-header-text">Activity</div>
              <div className="activity-subheader-text">Last 7 days</div>
            </div>

            <div className="activity-details-container">
              <span className="activity-number">{questionCount || ""}</span>
              <div className="column">
                <div className="activity-text">Questions</div>
                <div className="activity-text">Asked</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ResponseCardSection recentAnswers={recentAnswers} />
      <AnswerSidebar />
    </div>
  );
}
